$(document).ready(function () {
	
$(' .wrap_2, .wrap_3, .wrap_4, .wrap_5').wrapAll('<div class="footer_items--wrap">');
  $(".menu-and-heading h2").on("click", function(){
    $(this).parents(".menu-and-heading").find(".menu-items-footer-in").slideToggle();
    $(this).parents(".menu-and-heading").toggleClass("active-menu");
  })

  $("button.site-nav__thumb-button").on("click", function(){
     $(this).parents(".section-header").find(".slide-nav__overflow").toggleClass("js-menu--is-open");
     $(this).toggleClass("js-toggle-slide-nav");
    $(this).parents(".section-header").find(".slide-nav__overflow").find(".slide-nav__wrapper").toggleClass("js-menu-drawer-open");
  })
  if ($(".shopify-section").hasClass("announcement-bar-section")) {
  $("body").addClass("has_announcement");
}  
});

$(document).on("click","button.site-nav__thumb-button svg.icon.icon-close",function() {
  $(this).parents(".section-header").find(".slide-nav__overflow").find(".slide-nav__wrapper").find("ul").find("li").removeClass("gm-active");
  $(this).parents(".section-header").find(".slide-nav__overflow").find(".slide-nav__wrapper").find("ul.menu-drawer__menu li").find("ul.gm-submenu li").removeClass("gm-active");
});
// $(document).on("click","ul.slide-nav li a",function() {
//   $(this).parent("li").parent("ul").css("left", "-90%");
// });
// $(document).on("click","ul.slide-nav li.gm-active a",function() {
//   $(this).parent("li").parent("ul").css("left", "0");
// });

// $(document).on("click","ul.menu-drawer__menu.has-submenu.list-menu li a",function() {
//   $(this).parent("li").parent("ul").css("transition", "all 1s ease 0.15s!important;");  
// });
// $(document).on("click","ul.gm-submenu li a",function() {
//   $(".gm-submenu").css("transition", "all 1s ease 0.15s!important;");  
// });
